"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecursiveOperationRpcRemote = void 0;
const utils_1 = require("@streamr/utils");
const uuid_1 = require("uuid");
const RpcRemote_1 = require("../contact/RpcRemote");
const getPreviousPeer_1 = require("../routing/getPreviousPeer");
const identifiers_1 = require("../../identifiers");
const logger = new utils_1.Logger(module);
class RecursiveOperationRpcRemote extends RpcRemote_1.RpcRemote {
    async routeRequest(params) {
        const message = {
            target: params.target,
            sourcePeer: params.sourcePeer,
            message: params.message,
            requestId: params.requestId ?? (0, uuid_1.v4)(),
            reachableThrough: params.reachableThrough ?? [],
            routingPath: params.routingPath,
            parallelRootNodeIds: params.parallelRootNodeIds
        };
        const options = this.formDhtRpcOptions({
            connect: false
        });
        try {
            const ack = await this.getClient().routeRequest(message, options);
            if (ack.error !== undefined) {
                logger.trace('Next hop responded with error ' + ack.error);
                return false;
            }
        }
        catch (err) {
            const previousPeer = (0, getPreviousPeer_1.getPreviousPeer)(params);
            const fromNode = previousPeer
                ? (0, identifiers_1.toNodeId)(previousPeer)
                : (0, identifiers_1.toNodeId)(params.sourcePeer);
            const toNode = (0, identifiers_1.toNodeId)(this.getPeerDescriptor());
            logger.debug(`Failed to send routeRequest message from ${fromNode} to ${toNode}`, { err });
            return false;
        }
        return true;
    }
}
exports.RecursiveOperationRpcRemote = RecursiveOperationRpcRemote;
//# sourceMappingURL=RecursiveOperationRpcRemote.js.map